import React from 'react'
import { darkGray } from '../../conf'

const INSTAGRAM_API_URL =
    `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink,timestamp&access_token=${process.env.REACT_APP_INSTAGRAM_ACCESS_TOKEN}`

class NewsPage extends React.Component {

    state = {
        posts: [],
        loading: true,
        error: null
    }

    componentDidMount() {
        fetch(INSTAGRAM_API_URL)
            .then(res => {
                if (!res.ok) throw new Error('Errore nel caricamento del feed Instagram')
                return res.json()
            })
            .then(data => this.setState({ posts: data.data || [], loading: false }))
            .catch(err => this.setState({ error: err.message, loading: false }))
    }

    render() {
        const { posts, loading, error } = this.state

        return (
            <div>
                <div style={{
                    backgroundColor: darkGray,
                    padding: '40px 20px 30px',
                    textAlign: 'center'
                }}>
                    <h2 style={{ color: 'white', letterSpacing: '3px', margin: 0 }}>NEWS</h2>
                    <p style={{ color: '#cccccc', marginTop: '10px', marginBottom: 0 }}>
                        Seguici su Instagram{' '}
                        <a href="https://www.instagram.com/auto_lg/" target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
                            @auto_lg
                        </a>
                    </p>
                </div>

                <div style={{ backgroundColor: '#f5f5f5', padding: '40px 20px', minHeight: '600px' }}>
                    {loading && (
                        <p style={{ textAlign: 'center', color: '#888' }}>Caricamento...</p>
                    )}
                    {error && (
                        <p style={{ textAlign: 'center', color: 'red' }}>{error}</p>
                    )}
                    {!loading && !error && (
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                            gap: '12px',
                            maxWidth: '1200px',
                            margin: '0 auto'
                        }}>
                            {posts.map(post => (
                                <a
                                    key={post.id}
                                    href={post.permalink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'block', overflow: 'hidden', borderRadius: '4px' }}
                                >
                                    <img
                                        src={post.media_type === 'VIDEO' ? post.thumbnail_url : post.media_url}
                                        alt={post.caption || ''}
                                        style={{
                                            width: '100%',
                                            aspectRatio: '1',
                                            objectFit: 'cover',
                                            display: 'block',
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.03)'}
                                        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                    />
                                </a>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default NewsPage
